export default "__VITE_ASSET__T_GlDtZX__"